module.exports = __webpack_public_path__ + "static/media/foto_g.0e675d8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/foto_g.jpg
// module id = 1296
// module chunks = 0